import * as React from 'react';
import { colors } from '../../../index';

const IconOpenToLeft = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 11 12",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.1 5.56l-.02.03-.02.04-.02.03-.01.04-.01.04-.01.03v.12l.01.03.02.04.02.04a.18.18 0 00.01.03l.03.03.03.04 2.39 2.35a.42.42 0 00.58 0 .4.4 0 000-.58L1.43 6.22h6.66a.41.41 0 00.42-.41c0-.23-.2-.41-.42-.41H1.41l1.68-1.63a.4.4 0 000-.58.42.42 0 00-.58 0L.13 5.53l-.03.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73 10.82H5.64c-.23 0-.41.19-.41.41 0 .23.18.41.41.41h3.09c1.24 0 2.25-1 2.25-2.21V2.21C10.98.99 9.97 0 8.73 0H5.69a.406.406 0 100 .81h3.04c.78 0 1.42.63 1.42 1.4v7.22c0 .77-.64 1.4-1.42 1.4z"
  }));
};

export default IconOpenToLeft;